import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import getAssetUrl from '../../lib/CDNAsset.js';

import { Water, Recycle, Clock, Percent, PatchQuestion, DropletFill, Rulers, LifePreserver } from 'react-bootstrap-icons';

import loadable from '@loadable/component';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Card from 'react-bootstrap/Card';

import CentralLink from '..//CentralLink.js'

import StaticMap from '..//StaticMap.js'
import NonStaticMap from '..//NonStaticMap.js'

import { getSearchSewageByPlaceId } from '../../store/reducers/fmAPI.js';

import SpillCountExplainModal from '..//SpillCountExplainModal.js';
import SewageDischargeStationOperationalHistoryChart from '..//SewageDischargeStationOperationalHistoryChart.js';
import SewageDischargeStationSpillHistoryChart from '..//SewageDischargeStationSpillHistoryChart.js';
import NearBySewagePlace from '..//NearBySewagePlace.js';

import AdComponent from '..//AdComponent.js';

import { sendNavigateToSearchSewageReport } from '../GoogleAnalytics.js';

import CommonHeaders from '..//helmet-headers/CommonHeaders.js';
import Breadcrumbs, { CRUMBS } from '..//helmet-headers/Breadcrumbs.js';

const SewageDischargeStationVolumeHistoryChart = loadable(() => import('..//SewageDischargeStationVolumeHistoryChart.js'));

const MarkerLoadable = loadable(() => import('..//leaflet-loadables/MarkerLoadable.js'), { fallback: null, ssr: false });
const Popup = loadable(() => import('react-leaflet').then(module => ({ default: module.Popup })), { fallback: null, ssr: false });

function SewageSearchPlace({ place }) {

	const formatNumberOneDP = function(hours) {
		return Math.floor(hours*10)/10;
	}


	let firstYearNumber = null;
	let lastYearNumber = null;

	if(place.summaryByYear && Object.keys(place.summaryByYear).length > 0) {
		let first = Object.keys(place.summaryByYear)[0];
		let last = Object.keys(place.summaryByYear)[Object.keys(place.summaryByYear).length-1];
		firstYearNumber = place.summaryByYear[first].year;
		lastYearNumber = place.summaryByYear[last].year;
	}
	console.log(Object.keys(place.summaryByYear));

	let missingDataAmount = null;
	// if(summary.declaredOperationalUptime && summary.declaredOperationalUptime < 100) {
	let yearCount = 0;
	let totalYearCount = 0;
	let operUptime = Object.keys(place.summaryByYear).reduce(function(acca, year) {
		let declaredOperationalUptime = parseFloat(place.summaryByYear[year].declaredOperationalUptime);
		++totalYearCount;
		if(isNaN(declaredOperationalUptime)) {
			return acca;
		}

		++yearCount;
		return acca + declaredOperationalUptime;
	}, 0);
	operUptime = Math.floor(100*(operUptime / yearCount))/100;
	
	missingDataAmount = <><span>
		<span className="hX-scale15em">
			<Badge pill bg="secondary"><Percent /> {formatNumberOneDP(operUptime)}</Badge>
		</span><br />
		The stations, on average, have been monitoring for {formatNumberOneDP(operUptime)}% of the total time we have data for.<br />
		{totalYearCount > yearCount ? <span style={{fontSize: "0.8em"}}><i>Years with missing data have been excluded from this calculation.</i></span> : null}
		{totalYearCount > yearCount ? <br /> : null}
	</span></>
	// }


	let noRecords = false;
	if(place && place.sewageSummary) {
		if(!place.sewageSummary.numberRecords) {
			noRecords = true;
		}
	}

	let volumeBadge = null;
	let olympicPools = null;
	if(place.sewageSummary && place.sewageSummary.declaredVolumeM3 !== null) {
		olympicPools = Math.floor(parseInt(place.sewageSummary.declaredVolumeM3) / 2500).toLocaleString()
		volumeBadge = <span className="hX-scale15em">
			<Badge pill bg="danger"><Rulers /> {parseInt(place.sewageSummary.declaredVolumeM3).toLocaleString()} m3</Badge>
			{olympicPools ? <span> | </span> : null}
			{olympicPools ? <Badge pill bg="danger"><LifePreserver /> {olympicPools}</Badge> : null}
		</span>;
	}

	//View a sewage report for the {{ place.placeSubType }} of {{ place.placeName }}{{#place.placeCounty}}, {{ place.placeCounty }}{{/place.placeCounty}}.
	let metaDescription = "View a sewage spill report for the " + place.placeSubType + " of " + place.placeName + ", " + place.placeCounty + ".";
	


	return (
		<div>
			<CommonHeaders
				title={"Sewage Report - " + place.placeName}
				description={metaDescription}
			/>
			<Breadcrumbs
				builtinCrumbs={[CRUMBS.HOME, CRUMBS.DATA_EXPLORER, CRUMBS.SEARCH_SEWAGE]}
				leafCrumbs={[{
					name: place.placeName,
					path: '/data-explorer/search-sewage-report/'+place.placeId + "/"+place.placeName
				}]}
			/>
			{noRecords === false ? <Row>
				<Col xs={12}>
					<Row>
						<Col xs={12} className="header-bold text-white bg-dark hX-scale12em">Summary for {place.placeName}{firstYearNumber && lastYearNumber ? " " + firstYearNumber + "-" + lastYearNumber : null}</Col>
						<Col xs={12}>
							<center>
								<span className="hX-scale15em">
									<Badge pill bg="danger"><Recycle /> {place.sewageSummary.declaredCountedSpills} Spills</Badge> | <Badge pill bg="danger"><Clock /> {formatNumberOneDP(place.sewageSummary.declaredDurationHours)} hours</Badge>
								</span><br />
								<SpillCountExplainModal /><br />
								In the period we have records for{firstYearNumber && lastYearNumber ? ", " + firstYearNumber + "-" + lastYearNumber : null}, sewage has been discharged in, or near (~{Math.floor(place.sewageSummaryDistance/1.6)}mi.), {place.placeName} {place.sewageSummary.declaredCountedSpills} time(s).<br />
								Sewage has been discharged for a total of {formatNumberOneDP(place.sewageSummary.declaredDurationHours)} hour(s).<br />
								In total: {Math.floor(100*place.sewageSummary.declaredDurationHours/(24*365))/100} year(s)* of elapsed time.<br />
								{volumeBadge}
								{volumeBadge ? <br /> : null}
								{volumeBadge ? <span>
									In the period we have records for the volume of discharge, in cubic metres (m3), is {parseInt(place.sewageSummary.declaredVolumeM3).toLocaleString()} m3.
									{olympicPools ? <br /> : null}
									{olympicPools ? <span>This is around {olympicPools} olympic swimming pools.</span> : null}
									{olympicPools ? <br /> : null}
									{olympicPools ? <span style={{fontSize: "0.8em"}}><i>This total may exclude local stations which did not provide volume data.</i></span> : null}
								</span> : null}<br />
								{missingDataAmount}
								{missingDataAmount ? <br /> : null}<br />
							</center>
							<br />
						</Col>
						<Col xs={12} className="d-xs-block d-md-none bg-secondary text-white header-bold">Discharge Volume by Year</Col>
						{volumeBadge ? <Col xs={12} md={3}></Col> : null}
						{volumeBadge ? <Col xs={12} md={6}><SewageDischargeStationVolumeHistoryChart sewageHistory={place.summaryByYear} /></Col> : null}
						{volumeBadge ? <Col xs={12} md={3}></Col> : null}
						<Col xs={12} className="d-xs-block d-md-none bg-secondary text-white header-bold">Hours and Spills by Year</Col>
						<Col xs={12} md={6}><SewageDischargeStationSpillHistoryChart sewageHistory={place.summaryByYear} /></Col>
						<Col xs={12} className="d-xs-block d-md-none bg-secondary text-white header-bold">Uptime Yearly Summary (Average)</Col>
						<Col xs={12} md={6}><SewageDischargeStationOperationalHistoryChart sewageHistory={place.summaryByYear} removeUptimeReason={true} /></Col>
						{place.receivingWaters && place.receivingWaters.length > 1 ? <Col xs={12} className="bg-secondary text-white header-bold">Summary of Bodies Receiving Discharge</Col> : null}
						{place.receivingWaters && place.receivingWaters.length > 1 ? <Row><Col xs={12} style={{marginBottom: "2px"}}>{place.receivingWaters.map(function(waterName) {
									return <Badge style={{marginLeft: "2px"}} pill bg="primary"><DropletFill /> {waterName}</Badge>
								})}</Col></Row> : null}
						{place.nearByPlaces ? [
						<Col xs={12} key="placeHeader" className="bg-secondary text-white header-bold">View Summaries Nearby</Col>,
						<Col xs={12} key="placeList">
							{Object.keys(place.nearByPlaces).map(function(nearByPlaceKey) {
								const nearByPlace = place.nearByPlaces[nearByPlaceKey];
								return <NearBySewagePlace place={nearByPlace} />
							})}
							<CentralLink to={"/data-explorer/search-sewage-report"} onClick={function() {
								sendNavigateToSearchSewageReport();
							}}>
								<Button variant="secondary" size="sm"><b><i>Somewhere else?</i></b></Button>
							</CentralLink>
						</Col>
					] : null}
					</Row>
					{(process.env.REACT_APP_ENABLE_GOOGLE_ADS === "true") && <Row style={{marginTop: "17px", borderTop: "1px dashed black"}}>
						<Col xs={12}>
							<AdComponent
							  client="ca-pub-6790224688210339"
							  slot="6130981811"
							  format="fluid"
							  layoutKey="-fb+5w+4e-db+86"
							  responsive={true}
							/>
						</Col>
					</Row>}
					{place.summaryByYear ? <Row>
						<Col xs={12} className="bg-dark text-white header-bold hX-scale12em">{place.placeName} - Yearly Summary</Col>
					</Row> : null}
					{place.summaryByYear ? Object.keys(place.summaryByYear).sort().reverse().map(function(year) {
						const yearData = place.summaryByYear[year];

						let topOffenders = [];
						if(place.topOffenders && place.topOffenders[year]) {
							topOffenders = place.topOffenders[year].map(function(offender, ix) {
								if(!place.stations[offender.stationId] || !offender.declaredCountedSpills) {
									return null;
								}
								let station = place.stations[offender.stationId];

								let stationUrl = '/stations/' + offender.stationId + '/metric/' + offender.metricId;
								return <Col key={offender.metricId} xs={12} md={4}>
									<Card style={{ width: '100%', minHeight: "250px" }}>
								      <Card.Header>
								      	<h3>{ix+1}</h3>
								      </Card.Header>
								      <Card.Body style={{minHeight: "244px"}}>
								        <CentralLink to={stationUrl}>
									        <StaticMap
									      		lat={station.lat}
									      		lng={station.lng}
									      		style={{width: "100%", height: "110px"}}
									      		zoom={13}
									      	/>
									        <Card.Text>
									        <Badge pill bg="danger"><Recycle /> {offender.declaredCountedSpills || 0} Spills</Badge> | <Badge pill bg="danger"><Clock /> {formatNumberOneDP(offender.declaredDurationHours)} hours</Badge><br />
									        <b>{station.stationName}</b><br />
									        {offender.sewagePermitReference ? <span style={{fontSize: "0.7em"}}>Permit#: <i>{offender.sewagePermitReference}</i></span> : null}
									        </Card.Text>
									    </CentralLink>
								      </Card.Body>
								      <Card.Footer>
								      	<CentralLink to={stationUrl}>
								      		<Button variant="dark" size="sm">View Details</Button>
								      	</CentralLink>
								      </Card.Footer>
								    </Card><br />
								</Col>;
							});
						}

						let volumeBadge = null;
						let olympicPools = null;
						if(yearData.declaredVolumeM3) {
							olympicPools = Math.floor(parseInt(yearData.declaredVolumeM3) / 2500).toLocaleString()
							volumeBadge = <span className="hX-scale15em">
								<Badge pill bg="danger"><Rulers /> {parseInt(yearData.declaredVolumeM3).toLocaleString()} m3</Badge>
								{olympicPools ? <span> | </span> : null}
								{olympicPools ? <Badge pill bg="danger"><LifePreserver /> {olympicPools}</Badge> : null}
							</span>;
						}

						let isScotland = place && place.regionName && place.regionName === 'Scotland';

						return <Row>
							<Col xs={12} className="text-white bg-secondary header-bold">Summary for Year {year}</Col>
							<Col xs={12}>
								<center>
									<span className="hX-scale15em">
										<Badge pill bg="danger"><Recycle /> {yearData.declaredCountedSpills} Spills</Badge> | <Badge pill bg="danger"><Clock /> {formatNumberOneDP(yearData.declaredDurationHours)} hours</Badge>
									</span><br />
									<SpillCountExplainModal /><br />
									In {year}, sewage was discharged in, or near (~{Math.floor(place.sewageSummaryDistance/1.6)}mi.), {place.placeName} {yearData.declaredCountedSpills} time(s).<br />
									Sewage was discharged for a total of {formatNumberOneDP(yearData.declaredDurationHours)} hour(s).<br />
									In total: {Math.floor(100*yearData.declaredDurationHours/(24*365))/100} year(s)* of elapsed time.<br />
									{volumeBadge}
									{volumeBadge ? <br /> : null}
									{volumeBadge ? <span>
										The volume of discharge, in cubic metres (m3), was {parseInt(yearData.declaredVolumeM3).toLocaleString()} m3.
										{olympicPools ? <br /> : null}
										{olympicPools ? <span>This is around {olympicPools} olympic swimming pools.</span> : null}
									</span> : null}<br />
									<><span>
										<span className="hX-scale15em">
											<Badge pill bg="secondary"><Percent /> {formatNumberOneDP(yearData.declaredOperationalUptime)}</Badge>
										</span><br />
										The stations, on average, have been monitoring for {formatNumberOneDP(yearData.declaredOperationalUptime)}% of the total time in {year}.<br />
										{year >= 2023 || !isScotland ?
												<span style={{fontSize: "0.8em"}}><i>Stations with missing data have been excluded from this calculation.</i></span>
											  : <span style={{fontSize: "0.8em"}}><i>Pre-2023 uptime data is not available in Scotland.</i></span>
										}<br />
									</span></><br /><br />
								</center>
								<Row>
									<Col xs={12} md={1}></Col>
									<Col xs={12} md={10}>
										<b>Worst Stations in {year}</b>
									</Col>
									<Col xs={12} md={1}></Col>
									<Col xs={12} md={1}></Col>
									<Col xs={12} md={10}>
										<Row style={{marginBottom: "7px"}}>
											{topOffenders.length > 0 ? topOffenders : null}
											<Col xs={12}>
												<span style={{fontSize: "0.7em"}}><i>A single station may appear twice when there are multiple individual outlets in the top 3.</i></span>
											</Col>
										</Row>
									</Col>
									<Col xs={12} md={1}></Col>
								</Row>
							</Col>
						</Row>
					}) : null}
					<Row>
						<Col xs={12}><span style={{fontSize: "0.7em"}}><i><b>*</b> - Elapsed time, in years or days, is the sum of time across the station(s) for which discharge event(s) have occured.</i></span></Col>
					</Row>
				</Col>
			</Row> : <Row>
				<Col xs={12} className="bg-dark text-white header-bold">{place.placeName}</Col>
				<Col xs={12}>At present, we have <b>England, Scotland and Wales</b> in our dataset.<br />
				Only England has 100% coverage of its sewage overflow monitors. (At the time this was written, Aug '24).</Col>
				<Col xs={12}>Unfortunately, we have no records for <b>{place.placeName}</b>.</Col>
				<Col xs={12} style={{marginBottom: "5px", marginTop: "5px"}}> 
					<CentralLink to={"/data-explorer/search-sewage-report"}>
						<Button variant="dark" size="md">Search elsewhere</Button>
					</CentralLink>
				</Col>
			</Row>}
		</div>
	);
}

export default SewageSearchPlace;